import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { COUNTRIES } from '../data/Countries'
import { LANGUAGES } from '../data/Languages'

export default function Register() {
    const [username, setUsername]         = React.useState('')
    const [email, setEmail]               = React.useState('')
    const [password, setPassword]         = React.useState('')
    const [confirm, setConfirm]           = React.useState('')
    const [firstName, setFirstName]       = React.useState('')
    const [lastName, setLastName]         = React.useState('')
    const [city, setCity]                 = React.useState('')
    const [country, setCountry]           = React.useState('')
    const [language, setLanguage]         = React.useState('')
    const [dateOfBirth, setDateOfBirth]   = React.useState('')
    const [error, setError]               = React.useState('')
    const [loading, setLoading]           = React.useState(false)

    const { register, isAuthenticated } = useAuth()
    const navigate = useNavigate()

    React.useEffect(() => {
        if (isAuthenticated) navigate('/lobby', { replace: true })
    }, [isAuthenticated, navigate])

    async function handleSubmit(e) {
        e.preventDefault()
        setError('')

        if (password !== confirm) { setError('Passwords do not match'); return }
        if (password.length < 8)  { setError('Password must be at least 8 characters'); return }

        if (dateOfBirth) {
            const dob = new Date(dateOfBirth)
            const today = new Date()
            const age = today.getFullYear() - dob.getFullYear() -
                (today < new Date(today.getFullYear(), dob.getMonth(), dob.getDate()) ? 1 : 0)
            if (age < 16) { setError('You must be 16 years or older to play Bankroll'); return }
        }

        setLoading(true)
        try {
            await register(username, email, password, firstName, lastName, city, country, language, dateOfBirth)
            navigate('/lobby', { replace: true })
        } catch (err) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }

    const inputClass  = "px-3 py-2 border border-gray-300 rounded-md font-karla text-base outline-none focus:border-bankroll-primary"
    const selectClass = `${inputClass} bg-white`
    const labelClass  = "flex flex-col gap-1.5 font-semibold text-sm text-bankroll-text"

    return (
        <main className="flex w-full flex-col items-center justify-start px-5 py-6">
            <div className="bg-white rounded-xl w-full max-w-lg shadow-lg overflow-hidden">
                <div className="px-9 py-4">
                <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
                    <label className={labelClass}>
                        Username
                        <input className={inputClass} type="text" value={username} onChange={e => setUsername(e.target.value)} autoComplete="username" autoFocus required />
                    </label>

                    <label className={labelClass}>
                        Email
                        <input className={inputClass} type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" required />
                    </label>

                    <div className="flex gap-3">
                        <label className={`${labelClass} flex-1`}>
                            First name
                            <input className={inputClass} type="text" value={firstName} onChange={e => setFirstName(e.target.value)} autoComplete="given-name" />
                        </label>
                        <label className={`${labelClass} flex-1`}>
                            Last name
                            <input className={inputClass} type="text" value={lastName} onChange={e => setLastName(e.target.value)} autoComplete="family-name" />
                        </label>
                    </div>

                    <label className={labelClass}>
                        City
                        <input className={inputClass} type="text" value={city} onChange={e => setCity(e.target.value)} autoComplete="address-level2" />
                    </label>

                    <label className={labelClass}>
                        Country
                        <select className={selectClass} value={country} onChange={e => setCountry(e.target.value)} required>
                            <option value="">Select a country…</option>
                            {COUNTRIES.map(c => (
                                <option key={c} value={c}>{c}</option>
                            ))}
                        </select>
                    </label>

                    <label className={labelClass}>
                        Language
                        <select className={selectClass} value={language} onChange={e => setLanguage(e.target.value)} required>
                            <option value="">Select a language…</option>
                            {LANGUAGES.map(l => (
                                <option key={l} value={l}>{l}</option>
                            ))}
                        </select>
                    </label>

                    <label className={labelClass}>
                        Date of birth
                        <input className={inputClass} type="date" value={dateOfBirth} onChange={e => setDateOfBirth(e.target.value)} required />
                    </label>

                    <label className={labelClass}>
                        Password
                        <input className={inputClass} type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" required />
                    </label>

                    <label className={labelClass}>
                        Confirm password
                        <input className={inputClass} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" required />
                    </label>

                    {error && <p className="text-bankroll-danger text-sm m-0 font-semibold">{error}</p>}

                    <button
                        className="mt-1 py-3 bg-bankroll-primary text-white border-0 rounded-md font-karla text-base font-bold cursor-pointer hover:bg-bankroll-primary-hov disabled:opacity-60 disabled:cursor-default"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? 'Creating account…' : 'Create account'}
                    </button>
                </form>

                <p className="mt-5 text-sm text-gray-500 text-center">
                    Already have an account?{' '}
                    <Link className="text-bankroll-primary font-semibold no-underline hover:underline" to="/login">Sign in</Link>
                </p>
                </div>
            </div>
        </main>
    )
}
